var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.672 13.6C13.8601 13.0656 14.2314 12.6144 14.72 12.3272C15.2086 12.04 15.7831 11.9352 16.3418 12.0312C16.9004 12.1264 17.407 12.4176 17.7721 12.8512C18.137 13.2848 18.3369 13.8336 18.336 14.4C18.336 16 15.936 16.8 15.936 16.8M16 20H16.008M24 16C24 20.4184 20.4182 24 16 24C11.5818 24 8 20.4184 8 16C8 11.5816 11.5818 8 16 8C20.4182 8 24 11.5816 24 16Z",
    stroke: "#505780",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/Tip.8c3ba0606120d77ae268fbc64d33b54d.svg";
export { ForwardRef as ReactComponent };